<main *ngIf="company$ | async as company" class="container">
  <span i18n wizHeadTitle>Offres d'emploi {{ company.name }}</span>
  <span i18n wizHeadDescription>
    {{ company.name }} recrute ! Consultez toutes nos offres d'emploi et postulez en ligne.
  </span>

  <span class="container__background"></span>

  <header class="header">
    <app-logo
      class="header__logo"
      size="large"
      background="#ffffff"
      color="#8782ff"
      [item]="{
        logoUrl: company.logo,
        companyName: company.name
      }"
    ></app-logo>
    <h1 class="header__title">{{ company.name }}</h1>
    <h2 *ngIf="company.slogan" class="header__slogan">{{ company.slogan }}</h2>
  </header>

  <section class="content">
    <nav #navBar class="nav">
      <div class="nav-container">
        <div class="nav__links">
          <button
            class="nav__link btn btn--link"
            appScrollMenuItem
            appScrollMenuItemActive="nav__link--active"
            ngx-scroll-to="#home-anchor"
            [ngx-scroll-to-offset]="-400"
            appEventTracker
            eventCategory="Home"
            eventAction="Click Home"
            i18n
          >
            Accueil
          </button>
          <button
            *ngIf="(jobs$ | async)?.length > 0"
            class="nav__link btn btn--link"
            appScrollMenuItem
            appScrollMenuItemActive="nav__link--active"
            ngx-scroll-to="#jobs-anchor"
            [ngx-scroll-to-offset]="-69"
            i18n
            appEventTracker
            eventCategory="Home"
            eventAction="Click Jobs"
          >
            Nos offres
          </button>
        </div>

        <div class="nav__social" *ngIf="company?.socialNetworks?.length > 0">
          <span class="social__text" i18n>Nous suivre&nbsp;:</span>
          <div class="social__share" [@socialAnimation]>
            <a
              *ngFor="let social of company?.socialNetworks; trackBy: trackByMedia"
              class="share"
              [href]="social.url | linkProtocol"
              target="_blank"
              rel="noopener"
            >
              <img
                *ngIf="social.name !== 'website'"
                [src]="'assets/icons/social/' + social.name + '.svg'"
                [alt]="social.name"
                class="share__logo"
              />
              <div *ngIf="social.name === 'website'" class="share__logo share__website">
                <svg-icon class="share__website__icon" icon="exp-laptop" width="1.2em"></svg-icon>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="nav__divider"></div>
    </nav>

    <header *ngIf="company.slogan || company.description" class="content__header" appScrollContentItem id="home-anchor">
      <h2 *ngIf="company.slogan" class="content__title">{{ company.slogan }}</h2>
      <p *ngIf="company.description" class="content__description">{{ company.description }}</p>
    </header>

    <div class="content__jobs" appScrollContentItem id="jobs-anchor">
      <h3 *ngIf="(jobs$ | async)?.length > 0" class="content__title">
        <ng-container i18n>Nous avons</ng-container>
        {{ (jobs$ | async)?.length }}
        <ng-container [ngPlural]="(jobs$ | async).length || 0">
          <ng-template ngPluralCase="zero">
            <ng-container i18n>offre</ng-container>
          </ng-template>
          <ng-template ngPluralCase="one">
            <ng-container i18n>offre</ng-container>
          </ng-template>
          <ng-template ngPluralCase="other">
            <ng-container i18n>offres</ng-container>
          </ng-template>
        </ng-container>
        !
      </h3>

      <ng-container *ngIf="jobs$ | async as jobs; else skeleton">
        <list-job [@listAnimation]="jobs?.length" [list]="jobs"></list-job>
      </ng-container>

      <ng-template #skeleton>
        <list-job-skeleton class="view-skeleton" @skeletonEnter></list-job-skeleton>
      </ng-template>

      <footer *ngIf="(jobs$ | async)?.length >= (currentPage$ | async) * nbItemsToDisplay" class="content__footer">
        <a
          class="see-more btn btn--ghost"
          routerLink="."
          [queryParams]="{ page: (currentPage$ | async) + 1 }"
          fragment="bottom"
          queryParamsHandling="merge"
          i18n
        >
          Voir plus
        </a>
      </footer>

      <footer class="social social--footer" *ngIf="company?.socialNetworks?.length > 0">
        <h3 class="social__follow" i18n>Suivez-nous sur&nbsp;:</h3>
        <div class="social__share social__share--footer">
          <a
            *ngFor="let social of company.socialNetworks; trackBy: trackByMedia"
            [href]="social.url | linkProtocol"
            target="_blank"
            rel="noopener"
          >
            <img
              *ngIf="social.name !== 'website'"
              [src]="'assets/icons/social/' + social.name + '.svg'"
              [alt]="social.name"
              class="share__logo share__logo--footer"
            />
            <div *ngIf="social.name === 'website'" class="share__logo share__logo--footer share__website">
              <svg-icon class="share__website__icon" icon="exp-laptop" width="1.2em"></svg-icon>
            </div>
          </a>
        </div>
      </footer>
    </div>
  </section>

  <app-footer location="Home"></app-footer>
</main>
